import { Button, Card, message, Modal, Row, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import Get from "../services/Get";

const Withdraw = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [balances, setBalances] = useState({});
  const [totals, setTotals] = useState({});

  const getData = async () => {
    setLoading(true);
    try {
      const res = await Get.MLMLevelIncome();
      console.log(res);

      if (res.error) {
        message.error(res.error);
      } else {
        // setBalances(res.balance);
        setTotals(res.total);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {loading ? (
        <>
        <div className="f_led">
          <Skeleton.Node active={true} className="X_fsda" style={{width: '400px', height: '250px'}}/>
          <Skeleton.Node active={true} className="X_fsda" style={{width: '400px', height: '250px'}}/>
          <Skeleton.Node active={true} className="X_fsda" style={{width: '400px', height: '250px'}}/>
         
        </div>
        <div className="f_led">
        <Skeleton.Node active={true} className="X_fsda" style={{width: '600px', height: '250px'}}/>
        <Skeleton.Node active={true} className="X_fsda" style={{width: '600px', height: '250px'}}/>
        </div>
        </>
      ) : (
        <>
          <div className="f_led">
            <Card className="X_fsda">
              <Row className="sapn">
                <h3>Direct Income</h3>
                <h5>
                  Total Earnings : <span>₹{totals.direct}</span>{" "}
                </h5>
                {/* <h5>Balance : <span>₹{balances.direct}</span> </h5> */}
                {/* <Button className="form-btn" onClick={() => showModal('direct')}>Withdraw</Button> */}
              </Row>
            </Card>
            <Card className="X_fsda">
              <Row className="sapn">
                <h3>Level Income</h3>
                <h5>
                  Total Earnings : <span>₹{totals.level}</span>{" "}
                </h5>
                {/* <h5>Balance : <span>₹{balances.level}</span> </h5> */}
                {/* <Button className="form-btn" onClick={() => showModal('level')}>Withdraw</Button> */}
              </Row>
            </Card>
            <Card className="X_fsda">
              <Row className="sapn">
                <h3>Leadership Income</h3>
                <h5>
                  Total Earnings : <span>₹{totals.leadership}</span>{" "}
                </h5>
                {/* <h5>Balance : <span>₹{balances.leadership}</span> </h5> */}
                {/* <Button className="form-btn" onClick={() => showModal('leadership')}>Withdraw</Button> */}
              </Row>
            </Card>
          </div>
          <div className="f_led">
            <Card className="X_fsda">
              <Row className="sapn">
                <h3>Royality Income</h3>
                <h5>
                  Total Earnings : <span>₹{totals.royality}</span>{" "}
                </h5>
                {/* <h5>Balance : <span>₹{balances.royality}</span> </h5> */}
                {/* <Button className="form-btn" onClick={() => showModal('royality')}>Withdraw</Button> */}
              </Row>
            </Card>
            <Card className="X_fsda">
              <Row className="sapn">
                <h3>Utility Income</h3>
                <h5>
                  Total Earnings : <span>₹{totals.utility}</span>{" "}
                </h5>
                {/* <h5>Balance : <span>₹{balances.utility}</span> </h5> */}
                {/* <Button className="form-btn" onClick={() => showModal('utility')}>Withdraw</Button> */}
              </Row>
            </Card>
          </div>
        </>
      )}

      <Modal
        title="Basic Modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ className: "form-btn", loading: processing }}
      >
        <p>Some contents...</p>
        <p>Some contents...</p>
        <p>Some contents...</p>
      </Modal>
    </div>
  );
};

export default Withdraw;
